import type { ButtonProps as AntButtonProps } from 'antd';
import { Link } from 'react-router';

import { ButtonTypeEnum } from '@atom/button/button.enum';
import { isString } from '@util/data/is-exist';

import { AntButton } from './button.style';

export interface ButtonProps extends Omit<AntButtonProps, 'type'> {
  type?: ButtonTypeEnum;
  capitalized?: boolean;
}

export const Button = ({ type, href, ...props }: ButtonProps) => {
  const button = (() => {
    switch (type) {
      case ButtonTypeEnum.Primary:
        return <AntButton type='primary' {...props} />;
      case ButtonTypeEnum.Error:
        return <AntButton danger {...props} />;
      case ButtonTypeEnum.Text:
        return <AntButton type='text' {...props} />;
      case ButtonTypeEnum.Link:
        return <AntButton type='link' {...props} />;
      default:
        return <AntButton {...props} />;
    }
  })();

  return isString(href) ? <Link to={href}>{button}</Link> : button;
};
